module.exports = __webpack_public_path__ + "img/banner3.d0b9249.png";